import React, {
  createContext,
  Dispatch,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";
import { Filial } from "../models/Filial";

interface FilialContextType {
  dadosFilialRedux: Filial[];
  setDadosFilialRedux: Dispatch<React.SetStateAction<Filial[]>>;
}

const FilialCidade = createContext<FilialContextType | undefined>(undefined);

interface DadosFilialReduxProps {
  children: ReactNode;
}
const valorInicial: Filial[] = [];

export const DadosFilialRedux = ({ children }: DadosFilialReduxProps) => {
  const [dadosFilialRedux, setDadosFilialRedux] = useState<Filial[]>(() => {
    const dadosSalvos = localStorage.getItem("dadosFilial");
    const parsed = dadosSalvos ? JSON.parse(dadosSalvos) : valorInicial;

    return Array.isArray(parsed)
      ? parsed.sort((a, b) => a.nomeFilial.localeCompare(b.nomeFilial))
      : parsed;
  });

  useEffect(() => {
    localStorage.setItem("dadosFilial", JSON.stringify(dadosFilialRedux));
  }, [dadosFilialRedux]);

  return (
    <FilialCidade.Provider
      value={{
        dadosFilialRedux,
        setDadosFilialRedux,
      }}
    >
      {children}
    </FilialCidade.Provider>
  );
};

export const useCidade = () => {
  const context = useContext(FilialCidade);
  if (!context) {
    throw new Error("useCidade must be used within a FilialProvider");
  }
  return context;
};

export default useCidade;